/* ==========================================================================
   Emberly — product purchase logic (loaded only where a buy box renders)
   --------------------------------------------------------------------------
   One [data-em-product] root drives: option selectors → variant, offer
   tiers → quantity (or pack variant), live price / savings / CTA text,
   gallery sync, sticky bar, add-to-cart via Emberly.cart, delivery estimate.
   Every price is read from the variants JSON the section embeds (Shopify
   data) — nothing is typed by hand anywhere in the theme.
   ========================================================================== */
(function () {
  'use strict';
  if (window.EmberlyProduct) return;

  var doc = document;
  function qs(s, r) { return (r || doc).querySelector(s); }
  function qsa(s, r) { return Array.prototype.slice.call((r || doc).querySelectorAll(s)); }
  function money(c) { return window.Emberly && window.Emberly.money ? window.Emberly.money(c) : '$' + (c / 100).toFixed(2); }
  function str(key, fallback) { return (window.Emberly && window.Emberly.strings && window.Emberly.strings[key]) || fallback; }

  function ProductRoot(root) {
    this.root = root;
    root.setAttribute('data-em-init', '');
    var data = qs('[data-em-variants]', root);
    try { this.variants = JSON.parse(data ? data.textContent : '[]'); } catch (e) { this.variants = []; }
    this.form = qs('form[data-em-form]', root);
    if (!this.form || !this.variants.length) return;
    this.idInput = qs('[data-em-variant-id]', this.form);
    this.qtyInput = qs('[data-em-quantity]', this.form);
    this.qtyStepper = qs('[data-em-qty-stepper]', root);
    this.optionSets = qsa('[data-em-option]', root);
    this.tierInputs = qsa('[data-em-tier]', root);
    this.priceNow = qs('[data-em-price-now]', root);
    this.priceWas = qs('[data-em-price-was]', root);
    this.priceSave = qs('[data-em-price-save]', root);
    this.priceWrap = qs('[data-em-price]', root);
    this.atc = qs('[data-em-atc]', root);
    this.atcLabel = qs('[data-em-atc-label]', root);
    this.atcPrice = qs('[data-em-atc-price]', root);
    this.atcError = qs('[data-em-atc-error]', root);
    this.sticky = qs('[data-em-sticky]', root) || qs('[data-em-sticky][data-for="' + root.getAttribute('data-section') + '"]');
    this.gallery = qs('[data-em-gallery]', root);
    this.baseUnitPrice = 0;
    if (this.tierInputs.length && !this.tierInputs.some(function (r) { return r.checked; })) {
      var firstOk = this.tierInputs.filter(function (r) { return !r.disabled; })[0];
      if (firstOk) firstOk.checked = true;
    }
    this.bind();
    this.update(true);
    this.initSticky();
    this.initDelivery();
  }

  ProductRoot.prototype.bind = function () {
    var self = this;
    this.root.addEventListener('change', function (e) {
      var t = e.target;
      if (t.closest('[data-em-option]') || t.hasAttribute('data-em-tier')) self.update();
      if (t.hasAttribute('data-em-qty-value')) self.update();
    });
    this.root.addEventListener('click', function (e) {
      var step = e.target.closest('[data-em-qty-step]');
      if (step && self.qtyStepper && step.closest('[data-em-qty-stepper]')) {
        var input = qs('[data-em-qty-value]', self.qtyStepper);
        var min = parseInt(input.getAttribute('min'), 10) || 1;
        var next = Math.max(min, (parseInt(input.value, 10) || min) + parseInt(step.getAttribute('data-em-qty-step'), 10));
        input.value = next;
        self.update();
      }
      var thumb = e.target.closest('[data-em-thumb]');
      if (thumb && self.gallery && self.gallery.emGo) self.gallery.emGo(parseInt(thumb.getAttribute('data-em-thumb'), 10));
    });
    this.form.addEventListener('submit', function (e) {
      if (!window.Emberly || !window.Emberly.cart) return; // native fallback
      e.preventDefault();
      self.add(self.atc);
    });
    if (this.sticky) {
      var sBtn = qs('[data-em-sticky-atc]', this.sticky);
      if (sBtn) sBtn.addEventListener('click', function () { self.add(sBtn); });
    }
    // keyboard: arrow keys move between tier cards (radios already do this natively)
  };

  ProductRoot.prototype.selectedOptions = function () {
    return this.optionSets.map(function (set) {
      var checked = qs('input:checked', set) || qs('select', set);
      return checked ? checked.value : null;
    });
  };

  ProductRoot.prototype.findVariant = function (options) {
    for (var i = 0; i < this.variants.length; i++) {
      var v = this.variants[i], ok = true;
      for (var k = 0; k < options.length; k++) { if (options[k] !== null && v.options[k] !== options[k]) { ok = false; break; } }
      if (ok) return v;
    }
    return null;
  };

  ProductRoot.prototype.variantById = function (id) {
    id = parseInt(id, 10);
    for (var i = 0; i < this.variants.length; i++) if (this.variants[i].id === id) return this.variants[i];
    return null;
  };

  ProductRoot.prototype.currentTier = function () {
    var checked = this.tierInputs.filter(function (r) { return r.checked; })[0];
    if (!checked) return null;
    return {
      input: checked,
      card: checked.closest('[data-em-tier-card]'),
      units: parseInt(checked.getAttribute('data-units'), 10) || 1,
      qty: parseInt(checked.getAttribute('data-qty'), 10) || 1,
      variantId: checked.getAttribute('data-variant') ? parseInt(checked.getAttribute('data-variant'), 10) : null,
      label: checked.getAttribute('data-label') || ''
    };
  };

  ProductRoot.prototype.updateOptionAvailability = function (selected) {
    var self = this;
    this.optionSets.forEach(function (set, idx) {
      qsa('input[type="radio"]', set).forEach(function (input) {
        var trial = selected.slice();
        trial[idx] = input.value;
        var exists = false, available = false;
        self.variants.forEach(function (v) {
          var match = true;
          for (var k = 0; k < trial.length; k++) { if (trial[k] !== null && v.options[k] !== trial[k]) { match = false; break; } }
          if (match) { exists = true; if (v.available) available = true; }
        });
        var label = input.closest('[data-em-opt-value]') || input.parentElement;
        label.classList.toggle('is-unavailable', exists && !available);
        label.classList.toggle('is-missing', !exists);
      });
    });
  };

  ProductRoot.prototype.update = function (initial) {
    var selected = this.selectedOptions();
    var tier = this.currentTier();
    // the variant chosen through the option selectors (or the only one); pack tiers override it
    var optionVariant = this.optionSets.length ? this.findVariant(selected) : this.variants[0];
    var variant = null;
    if (tier && tier.variantId) variant = this.variantById(tier.variantId);
    if (!variant) variant = optionVariant;
    this.variant = variant;
    if (this.optionSets.length) this.updateOptionAvailability(selected);

    var qty = 1, units = 1;
    if (tier) { qty = tier.qty; units = tier.units; }
    else if (this.qtyStepper) { var qi = qs('[data-em-qty-value]', this.qtyStepper); qty = Math.max(1, parseInt(qi.value, 10) || 1); }

    // base unit price = price of the single-unit reference (tier with units=1, or the variant price)
    var unitRef = optionVariant ? optionVariant.price : (variant ? variant.price : 0);
    if (tier) {
      var ref = this.tierInputs.filter(function (r) { return (parseInt(r.getAttribute('data-units'), 10) || 1) === 1; })[0];
      if (ref) {
        var refVariant = ref.getAttribute('data-variant') ? this.variantById(ref.getAttribute('data-variant')) : optionVariant;
        if (refVariant) unitRef = refVariant.price * (parseInt(ref.getAttribute('data-qty'), 10) || 1);
      }
    }

    var total = variant ? variant.price * qty : 0;
    var reference = unitRef * units;
    var compare = variant && variant.compare_at_price ? variant.compare_at_price * qty : 0;
    var was = 0;
    if (compare > total) was = compare; else if (reference > total) was = reference;
    var saving = was > total ? was - total : 0;
    var available = !!(variant && variant.available);

    // hidden inputs
    if (variant && this.idInput) this.idInput.value = variant.id;
    if (this.qtyInput) this.qtyInput.value = qty;

    // tier cards (quantity tiers follow the selected variant's price)
    var self = this;
    this.tierInputs.forEach(function (r) {
      var card = r.closest('[data-em-tier-card]');
      if (!card) return;
      var tUnits = parseInt(r.getAttribute('data-units'), 10) || 1;
      var tQty = parseInt(r.getAttribute('data-qty'), 10) || 1;
      var tVariant = r.getAttribute('data-variant') ? self.variantById(r.getAttribute('data-variant')) : optionVariant;
      if (!tVariant) return;
      var tTotal = tVariant.price * tQty;
      var tRef = unitRef * tUnits;
      var tCompare = tVariant.compare_at_price ? tVariant.compare_at_price * tQty : 0;
      var tWas = tCompare > tTotal ? tCompare : (tRef > tTotal ? tRef : 0);
      var tSave = tWas > tTotal ? tWas - tTotal : 0;
      var now = qs('[data-em-tier-now]', card), wasEl = qs('[data-em-tier-was]', card), each = qs('[data-em-tier-each]', card), save = qs('[data-em-tier-save]', card);
      if (now) now.textContent = tVariant.available ? money(tTotal) : str('soldOut', 'Sold out');
      if (wasEl) { wasEl.textContent = tWas ? money(tWas) : ''; wasEl.hidden = !tWas || !tVariant.available; }
      if (each) { each.textContent = str('each', '[price] each').replace('[price]', money(Math.round(tTotal / tUnits))); each.hidden = tUnits < 2 || !tVariant.available; }
      if (save) { save.textContent = str('save', 'Save [amount]').replace('[amount]', money(tSave)); save.hidden = !tSave || !tVariant.available; }
      r.disabled = !tVariant.available;
      card.classList.toggle('is-soldout', !tVariant.available);
    });

    // main price
    if (this.priceNow) this.priceNow.textContent = money(total);
    if (this.priceWas) { this.priceWas.textContent = was ? money(was) : ''; this.priceWas.hidden = !was; }
    if (this.priceSave) { this.priceSave.textContent = str('save', 'Save [amount]').replace('[amount]', money(saving)); this.priceSave.hidden = !saving; }
    if (this.priceWrap) this.priceWrap.classList.toggle('em-price--sale', saving > 0);

    // CTA
    if (this.atc) {
      this.atc.disabled = !available;
      this.atc.setAttribute('aria-disabled', available ? 'false' : 'true');
      if (this.atcLabel) this.atcLabel.textContent = !variant ? str('unavailable', 'Unavailable') : (available ? (this.atc.getAttribute('data-label') || str('addToCart', 'Add to cart')) : str('soldOut', 'Sold out'));
      if (this.atcPrice) { this.atcPrice.textContent = money(total); this.atcPrice.hidden = !available; }
    }
    if (this.atcError && !initial) this.atcError.textContent = '';

    // sticky bar
    if (this.sticky) {
      var sp = qs('[data-em-sticky-price]', this.sticky), st = qs('[data-em-sticky-option]', this.sticky), sb = qs('[data-em-sticky-atc]', this.sticky);
      if (sp) sp.textContent = money(total);
      if (st) st.textContent = tier ? tier.label : (variant && variant.title !== 'Default Title' ? variant.title : '');
      if (sb) { sb.disabled = !available; var sl = qs('[data-em-sticky-label]', sb); if (sl) sl.textContent = available ? (sb.getAttribute('data-label') || str('addToCart', 'Add to cart')) : str('soldOut', 'Sold out'); }
    }

    // gallery + URL
    if (variant && variant.featured_media_id && this.gallery && this.gallery.emGo && !initial) {
      var slides = qsa('[data-em-slide]', this.gallery);
      for (var i = 0; i < slides.length; i++) {
        if (parseInt(slides[i].getAttribute('data-media-id'), 10) === variant.featured_media_id) { this.gallery.emGo(i); break; }
      }
    }
    if (variant && !initial && window.history && window.history.replaceState && this.root.getAttribute('data-update-url') === 'true') {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }

    this.root.dispatchEvent(new CustomEvent('em:product:change', { detail: { variant: variant, quantity: qty, total: total, tier: tier } }));
  };

  ProductRoot.prototype.add = function (button) {
    var self = this;
    if (!this.variant || !this.variant.available) return;
    if (button && button.classList.contains('is-loading')) return;
    var qty = parseInt(this.qtyInput ? this.qtyInput.value : 1, 10) || 1;
    var props = {};
    qsa('input[name^="properties["], select[name^="properties["], textarea[name^="properties["]', this.form).forEach(function (el) {
      if ((el.type === 'checkbox' || el.type === 'radio') && !el.checked) return;
      var name = el.name.replace(/^properties\[(.*)\]$/, '$1');
      if (el.value !== '') props[name] = el.value;
    });
    var plan = qs('[name="selling_plan"]', this.form);
    var item = { id: this.variant.id, quantity: qty, properties: props };
    if (plan && plan.value) item.selling_plan = plan.value;
    if (button) button.classList.add('is-loading');
    if (this.atcError) this.atcError.textContent = '';
    return window.Emberly.cart.add([item])
      .catch(function (err) {
        var msg = (err && err.message) || str('addError', 'Could not add to cart. Please try again.');
        if (self.atcError) self.atcError.textContent = msg; else window.Emberly.announce(msg);
      })
      .then(function () { if (button) button.classList.remove('is-loading'); });
  };

  ProductRoot.prototype.initSticky = function () {
    var self = this;
    if (!this.sticky || !this.atc || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      var en = entries[0];
      var show = !en.isIntersecting && en.boundingClientRect.top < 0;
      self.sticky.classList.toggle('is-visible', show);
      self.sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      doc.documentElement.classList.toggle('em-has-sticky', show);
    }, { threshold: 0 });
    io.observe(this.atc);
  };

  ProductRoot.prototype.initDelivery = function () {
    var el = qs('[data-em-delivery]', this.root);
    if (!el) return;
    function addBusinessDays(d, n) {
      var out = new Date(d);
      while (n > 0) { out.setDate(out.getDate() + 1); var w = out.getDay(); if (w !== 0 && w !== 6) n--; }
      return out;
    }
    var min = parseInt(el.getAttribute('data-min'), 10) || 0;
    var max = parseInt(el.getAttribute('data-max'), 10) || min;
    var cutoff = parseInt(el.getAttribute('data-cutoff-hour'), 10);
    var now = new Date();
    if (!isNaN(cutoff) && now.getHours() >= cutoff) { min += 1; max += 1; }
    var fmt = { weekday: 'short', month: 'short', day: 'numeric' };
    var a = addBusinessDays(now, min).toLocaleDateString(undefined, fmt);
    var b = addBusinessDays(now, max).toLocaleDateString(undefined, fmt);
    var out = qs('[data-em-delivery-dates]', el);
    if (out) out.textContent = a === b ? a : a + ' – ' + b;
    el.hidden = false;
  };

  function init(scope) {
    qsa('[data-em-product]:not([data-em-init])', scope).forEach(function (root) { new ProductRoot(root); });
  }
  window.EmberlyProduct = { init: init };
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', function () { init(doc); }); else init(doc);
  doc.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
